module.exports = __webpack_public_path__ + "img/caret-left-square.8e07fb72.svg";